
export const wrapPrefix = (pattern: RegExp, text: string, className: string) => {
  const match = text.match(pattern);
  if (match) {
    const rest = text.replace(pattern, "");
    return (
      <span>
        <span className={className}>{match[1]}</span>
        {rest}
      </span>
    );
  }
  return text;
};
